import { React, useEffect, useState } from 'react'
import { Container, Nav, Navbar, Offcanvas, Row, Stack, Table, Modal, Button, Form, Alert, Card, Col, Spinner } from 'react-bootstrap';
import Login from '../Components/Admin/Login';
import { onAuthStateChanged } from 'firebase/auth';
import Navigation from '../Components/Admin/Navigation';
import { db, auth } from '../utils/firebase'
import moment from 'moment';

export default function UkiesAdminFiles(props) {
    const [ token, setToken ] = useState(localStorage.getItem('ukies-webinars-accessToken'))
    const [ user, setUser ] = useState(JSON.parse(localStorage.getItem('ukies-webinars-admin')))
    const [ assets, setAssets ] = useState({ hits: [] })
    const [ assetList, setAssetList ] = useState([])
    const [ preview, setPreview ] = useState('')
    const [ search, setSearch ] = useState('')
    const [ selected, setSelected ] = useState({ id: 0 })
    const [ loading, setLoading ] = useState(false)
    const [ uploadingAsset, setUploadingAsset ] = useState(false)
    const [ showAlert, setShowAlert ] = useState(false)
    const [ alertMessage, setAlertMessage ] = useState('')
    const [ alertType, setAlertType ] = useState('success')
    const [ authReady, setAuthReady ] = useState(false)
    const [ filterAfbeeldingen, setFilterAfbeeldingen ] = useState(true)
    const [ filterVideos, setFilterVideos ] = useState(false)
    const [ filterDocumenten, setFilterDocumenten ] = useState(false)

    // Token for API calls
    const apiToken = process.env.REACT_APP_UKIES_API_TOKEN;

    // Auth state listener
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setAuthReady(true);
            } else {
                localStorage.removeItem('ukies-webinars-admin')
                localStorage.removeItem('ukies-webinars-accessToken')
                setToken()
                setUser()
                setAuthReady(false);
            }
        })
        
        return () => unsubscribe();
    }, []);

    // Set page title
    useEffect(() => {
        document.title = 'Ukies Admin - Bestanden';
    }, []);

    // Add custom styles to match UkiesAdminSeries
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            /* Override Bootstrap primary color */
            .btn-primary {
                background-color: #3b4f46 !important;
                border-color: #3b4f46 !important;
            }
            .btn-primary:hover {
                background-color: #2d3d35 !important;
                border-color: #2d3d35 !important;
            }
            .btn-primary:focus, .btn-primary.focus {
                background-color: #2d3d35 !important;
                border-color: #2d3d35 !important;
                box-shadow: 0 0 0 0.2rem rgba(59, 79, 70, 0.5) !important;
            }
            .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active {
                background-color: #243028 !important;
                border-color: #243028 !important;
            }
            .btn-outline-primary {
                color: #3b4f46 !important;
                border-color: #3b4f46 !important;
            }
            .btn-outline-primary:hover {
                background-color: #3b4f46 !important;
                border-color: #3b4f46 !important;
            }
            .btn-outline-primary:focus, .btn-outline-primary.focus {
                box-shadow: 0 0 0 0.2rem rgba(59, 79, 70, 0.5) !important;
            }
            .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active {
                background-color: #3b4f46 !important;
                border-color: #3b4f46 !important;
            }
            .btn-outline-secondary {
                color: #6c757d !important;
                border-color: #6c757d !important;
            }
            .btn-outline-secondary:hover {
                background-color: #6c757d !important;
                border-color: #6c757d !important;
            }
            .btn-outline-secondary:focus, .btn-outline-secondary.focus {
                box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5) !important;
            }
            .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active {
                background-color: #6c757d !important;
                border-color: #6c757d !important;
            }
            
            /* Ensure page can scroll properly and sticky positioning works */
            html, body {
                overflow-y: auto !important;
                height: auto !important;
            }
            body {
                position: relative !important;
            }
            
            /* Custom checkbox styling with ukies orange */
            .form-check-input:checked {
                background-color: var(--ukies-dark-orange) !important;
                border-color: var(--ukies-dark-orange) !important;
            }
            .form-check-input:focus {
                border-color: var(--ukies-dark-orange) !important;
                box-shadow: 0 0 0 0.25rem rgba(255, 136, 0, 0.25) !important;
            }
            .form-check-input:checked:focus {
                background-color: var(--ukies-dark-orange) !important;
                border-color: var(--ukies-dark-orange) !important;
                box-shadow: 0 0 0 0.25rem rgba(255, 136, 0, 0.25) !important;
            }
            
            /* Fix checkbox vertical alignment */
            .form-check {
                display: flex !important;
                align-items: center !important;
                margin-bottom: 0 !important;
            }
            .form-check-input {
                margin-top: 0 !important;
                margin-right: 0.375rem !important;
            }
        `;
        document.head.appendChild(style);
        
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    // Load files when component mounts and auth is ready
    useEffect(() => {
        if (authReady) {
            getFiles();
        }
    }, [authReady]);

    // Filter assets to show all file types (not just images like UkiesAssets)
    useEffect(() => {
        setAssetList(assets.hits || [])
    }, [assets])

    // Refresh files when filters change
    useEffect(() => {
        if (authReady) {
            getFiles();
        }
    }, [filterAfbeeldingen, filterVideos, filterDocumenten])

    const getFiles = () => {
        setLoading(true)
        
        // Build filter array based on selected checkboxes
        let filters = [];
        let extensions = [];
        
        if (filterAfbeeldingen) extensions.push("'jpg'", "'png'", "'webp'");
        if (filterVideos) extensions.push("'mp4'");
        if (filterDocumenten) extensions.push("'pdf'");
        
        // Always add extension filter - empty array if nothing selected
        filters.push([`extension IN [${extensions.join(', ')}]`]);
        
        fetch('https://ukies-api-search.eliteswitch.com/indexes/files/search', {
            method: 'POST',
            headers: {
                "authorization": 'Bearer ' + apiToken,
                "content-type": 'application/json'
            },
            body: JSON.stringify({
                "q": search,
                "sort": ["id:desc"],
                "matchingStrategy": "all",
                "facets": ["*"],
                "filter": filters,
                "offset": 0,
                "limit": 40000
            })
        })
            .then((response) => { return (response.json()) })
            .then((response) => {
                setAssets({ ...response })
                setLoading(false)
            })
            .catch((error) => {
                console.error('Error fetching assets:', error)
                setShowAlert(true);
                setAlertMessage('Fout bij het ophalen van bestanden.');
                setAlertType('danger');
                setLoading(false)
            })
    }

    const uploadFile = async (e) => {
        if (!e.target.files || e.target.files.length === 0) return;
        
        setUploadingAsset(true)
        
        try {
            const file = e.target.files[0];
            const isImage = file.type.startsWith('image/');
            
            let fileToUpload = file;
            
            // If it's an image, compress it like in UkiesAssets
            let resizeMessage = null;
            if (isImage) {
                const reduce = require('image-blob-reduce')();
                let image = await reduce.toBlob(file, { max: 3840 });
                let imageSize = image.size;

                // If image filesize is > 2mb, reduce by 200px till it's under 2mb
                if (imageSize > 1999999) {
                    let newSize = 3600;
                    while (imageSize > 1999999 && newSize > 800) {
                        image = await reduce.toBlob(file, { max: newSize });
                        imageSize = image.size;
                        if (imageSize > 1999999) {
                            newSize -= 200;
                        }
                    }
                    console.log('De afbeelding moest verkleind worden tot ' + newSize + 'px om onder de 2mb uploadlimiet te blijven.');
                    resizeMessage = `De afbeelding moest verkleind worden tot ${newSize}px om onder de 2mb uploadlimiet te blijven.`;
                }
                
                fileToUpload = new File([image], file.name, { type: file.type });
            }

            // Upload file to Eliteswitch
            let payload = new FormData()
            payload.append('file[]', fileToUpload)

            const response = await fetch('https://ukies-api.eliteswitch.com/api/file', {
                method: 'POST',
                headers: {
                    "authorization": 'Bearer ' + apiToken,
                },
                body: payload
            });

            const result = await response.json();
            
            // Update assets list with new file
            let tmpAssets = assets;
            tmpAssets.hits.unshift(result.result.items[0]);
            setAssets({ ...tmpAssets });
            
            setShowAlert(true);
            setAlertMessage(isImage && resizeMessage ? 
                `Bestand succesvol geüpload! ${resizeMessage}` : 
                'Bestand succesvol geüpload!'
            );
            setAlertType('success');
            
        } catch (error) {
            console.error('Error uploading file:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het uploaden van het bestand.');
            setAlertType('danger');
        } finally {
            setUploadingAsset(false);
        }
    }

    const handleRefresh = (e) => {
        e.preventDefault()
        getFiles()
    }

    // Helper function to format file size
    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    // Helper function to get file icon based on extension
    const getFileIcon = (extension) => {
        const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];
        const videoExts = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm'];
        const audioExts = ['mp3', 'wav', 'flac', 'aac', 'ogg'];
        const docExts = ['pdf', 'doc', 'docx', 'txt', 'rtf'];
        
        if (imageExts.includes(extension?.toLowerCase())) return '🖼️';
        if (videoExts.includes(extension?.toLowerCase())) return '🎥';
        if (audioExts.includes(extension?.toLowerCase())) return '🎵';
        if (docExts.includes(extension?.toLowerCase())) return '📄';
        return '📁';
    };

    // Helper function to copy URL to clipboard
    const copyUrlToClipboard = (asset) => {
        if (asset.cf_img_uid) {
            const url = `https://imagedelivery.net/rHj-gKo2iv8uX7Gew5qNsg/${asset.cf_img_uid}/w=orig`;
            navigator.clipboard.writeText(url).then(() => {
                setShowAlert(true);
                setAlertMessage('URL gekopieerd naar klembord!');
                setAlertType('success');
            }).catch((error) => {
                console.error('Error copying to clipboard:', error);
                setShowAlert(true);
                setAlertMessage('Fout bij kopiëren naar klembord.');
                setAlertType('danger');
            });
        } else {
            setShowAlert(true);
            setAlertMessage('Geen URL beschikbaar voor dit bestand.');
            setAlertType('warning');
        }
    };

    // Auto-hide alert after 5 seconds
    useEffect(() => {
        if (showAlert) {
            const timer = setTimeout(() => {
                setShowAlert(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [showAlert]);

    if(!token) {
        return <Stack><Login user={user} setUser={setUser} token={token} setToken={setToken} /></Stack>
    }

    return (
        <>
            <Navigation user={user} currentPage='files' />
            {showAlert && (
                <Alert 
                    variant={alertType} 
                    dismissible 
                    onClose={() => setShowAlert(false)} 
                    style={{
                        position: 'fixed',
                        top: '15px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 1060,
                        minWidth: '300px',
                        maxWidth: '600px'
                    }}
                >
                    {alertMessage}
                </Alert>
            )}
            
            <div className="container-fluid" style={{marginTop:'50px',padding:'0', minHeight: '100vh', overflow: 'auto'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', padding: '1rem 1rem 0 1rem'}}>
                    <h1 style={{fontSize:'2.5rem'}}>Bestanden</h1>
                </div>

                {(loading || uploadingAsset) && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.70)',
                        zIndex: 1000,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Spinner animation="border" variant="light" />
                        <div style={{ color: '#fff', padding: '1rem' }}>
                            {loading ? 'Bestanden worden geladen...' : 'Upload bezig...'}
                        </div>
                    </div>
                )}

                <div className="mb-3" style={{position:'fixed', top:'49px', left:'50%', transform:'translateX(-50%)', width:'calc(100% - 2rem)', maxWidth:'1200px', zIndex:'1000', backgroundColor:'#fff', padding: '1rem 1rem 0rem 1rem'}}>
                    {/* First row: Search and upload button */}
                    <div className="d-flex justify-content-between align-items-center mb-2 gap-2">
                        <Form onSubmit={handleRefresh} className="d-flex align-items-center flex-grow-1">
                            <Form.Control
                                type="text"
                                placeholder="Zoek naar bestanden"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                style={{ flexGrow: 1, maxWidth: '500px', borderTopRightRadius: '0', borderBottomRightRadius: '0' }}
                            />
                            <Button type="submit" variant="primary" size="sm" className="d-flex align-items-center" style={{ borderTopLeftRadius: '0', borderBottomLeftRadius: '0', height: '37.6px', width: '37.6px', justifyContent: 'center' }}>
                                <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                </svg>
                            </Button>
                        </Form>
                        <div>
                            <label htmlFor="file-upload">
                                <Button as="span" variant="primary" size="sm" className="d-flex align-items-center" style={{height: '37.6px', padding: '0 1rem'}}>
                                    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" className="me-1">
                                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                        <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
                                    </svg>
                                    Upload bestand
                                </Button>
                            </label>
                            <input
                                accept="*/*"
                                hidden
                                id="file-upload"
                                type="file"
                                onChange={uploadFile}
                            />
                        </div>
                    </div>
                    
                    {/* Second row: Checkboxes and results count */}
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center gap-2">
                            <Form.Check
                                type="checkbox"
                                id="filter-afbeeldingen"
                                label="Afbeeldingen"
                                checked={filterAfbeeldingen}
                                onChange={(e) => setFilterAfbeeldingen(e.target.checked)}
                                className="me-2"
                                style={{ fontSize: '0.8rem' }}
                            />
                            <Form.Check
                                type="checkbox"
                                id="filter-videos"
                                label="Videos"
                                checked={filterVideos}
                                onChange={(e) => setFilterVideos(e.target.checked)}
                                className="me-2"
                                style={{ fontSize: '0.8rem' }}
                            />
                            <Form.Check
                                type="checkbox"
                                id="filter-documenten"
                                label="Documenten"
                                checked={filterDocumenten}
                                onChange={(e) => setFilterDocumenten(e.target.checked)}
                                className="me-2"
                                style={{ fontSize: '0.8rem' }}
                            />
                        </div>
                        <div style={{ fontStyle: 'italic', fontSize: '0.9rem', color: '#6c757d' }}>
                            {assetList.length} resultaten
                        </div>
                    </div>
                    
                    {/* Horizontal rule */}
                    <hr />
                </div>
                
                <div style={{padding: '50px 1rem 0 1rem'}}>
                {assetList.length > 0 ? (
                    <Row>
                        {assetList.map((asset) => {
                            const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(asset.extension?.toLowerCase());
                            return (
                                <Col key={asset.id} xs={12} sm={12} md={6} lg={4} xl={3} className="mb-3">
                                    <Card 
                                        className='ukies-asset-card'
                                        onClick={() => setSelected(asset)}
                                        onDoubleClick={() => {
                                            if (isImage) {
                                                setPreview(asset.image_variations?.large?.replace('large', 'w=3840') || asset.url);
                                            }
                                        }}
                                    >
                                        <div style={{
                                            height: '200px',
                                            overflow: 'hidden',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            backgroundColor: '#567a7030'
                                        }}>
                                            {isImage ? (
                                                <img
                                                    src={asset.image_variations?.large || asset.url}
                                                    alt={asset.name}
                                                    style={{
                                                        maxWidth: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover'
                                                    }}
                                                />
                                            ) : (
                                                <div style={{
                                                    fontSize: '4rem',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    gap: '0.5rem'
                                                }}>
                                                    <span>{getFileIcon(asset.extension)}</span>
                                                    <span style={{
                                                        fontSize: '0.8rem',
                                                        backgroundColor: '#e9ecef',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px'
                                                    }}>
                                                        {asset.extension?.toUpperCase() || 'FILE'}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        <Card.Body style={{ fontSize: '0.8rem', padding: '0.5rem' }}>
                                            <div style={{ fontWeight: 'bold', marginBottom: '0.25rem' }}>
                                                {asset.name}
                                            </div>
                                            <div style={{ color: '#6c757d', fontSize: '0.7rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <span>{asset.extension?.toUpperCase() || 'FILE'} - {formatFileSize(asset.size)}</span>
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        copyUrlToClipboard(asset);
                                                    }}
                                                    className="d-flex align-items-center"
                                                    style={{fontSize: '0.7rem', padding: '0.3rem 0.5rem'}}
                                                >
                                                    <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" className='me-1'>
                                                        <path d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z"/>
                                                    </svg>
                                                    <span>Link</span>
                                                </Button>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )
                        })}
                    </Row>
                ) : !loading ? (
                    <Card>
                        <Card.Body style={{textAlign: 'center', padding: '3rem'}}>
                            <div style={{fontSize: '1.1rem', color: '#6c757d'}}>
                                Geen bestanden gevonden
                            </div>
                            <div style={{fontSize: '0.9rem', color: '#6c757d', marginTop: '0.5rem'}}>
                                Upload bestanden of probeer een andere zoekopdracht
                            </div>
                        </Card.Body>
                    </Card>
                ) : null}
                </div>
            </div>

            {/* Preview Modal */}
            <Modal show={preview.length > 0} onHide={() => setPreview('')} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <img src={preview} alt="Preview" style={{ maxWidth: '100%', height: 'auto' }} />
                </Modal.Body>
            </Modal>
        </>
    );
} 